"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_doc_fill_style_1 = __importDefault(require("./uicon.doc.fill.style"));
class UiconDocFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM9.33701 10.4922H14.777V11.7922H9.33701V10.4922ZM21.964 15.0251H9.33701V16.3251H21.964V15.0251ZM9.33701 19.5083H21.964V20.8083H9.33701V19.5083Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconDocFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconDocFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_doc_fill_style_1.default)(UiconDocFill);
//# sourceMappingURL=uicon.doc.fill.js.map